export function setMapscloudUser(state, user) {
    state.mapscloudUser = user
}
export function setCartoConfig(state, config) {
    state.cartoConfig = config
}
export function setLoginError(state, error) {
    state.loginError = error
}
export function setCartoConfigError(state, error) {
    state.cartoConfigError = error
}

export function setCartoUserCreateionState(state, cstate) {

    state.cartoUserCreationState = cstate
}